import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../hoc/Loading/Loading';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import { connect } from 'react-redux';
import {  uploadPreview, checkUploadType } from '../../../utils/constants';
import moment from 'moment';
import * as url from '../../../utils/url';
import { Card, CardBody, CardImg, CardTitle, CardText, Input, Row, Col } from "reactstrap";
import CKEditorUI from '../../../components/CKEditor/CKEditorUI';
import noAttachments from '../../../assets/upload_file.svg';


class InsightTitle extends Component {
  constructor(props) {
    super(props);
    this.state = { 
        name:this.props.singleNote&&this.props.singleNote.name?this.props.singleNote.name:'',
        actionType: this.props.actionType
     }
  }
  
  componentDidMount(){
    // this.getAttachedItems()
  }

componentDidUpdate(prevProps){
  let name = this.props.singleNote && this.props.singleNote.name?this.props.singleNote.name:''
  let prevName = prevProps.singleNote && prevProps.singleNote.name?prevProps.singleNote.name:''
  if(prevName !=name){
    this.setState({name, canEdit:this.props.canEdit})
  }

  if(prevProps.actionType!= this.props.actionType){
    this.setState({actionType:this.props.actionType})
  }
}

handleChangeInsightTitle = (event) => {
    const { value } = event.target;
    this.setState({ name:value })
}



submitInsightTitle= () =>{
  let{name}=this.state
  this.props.submitChartInsight(name)
}


openCreateChartReport=()=>{
  this.props.openCreateChartReport()
}

renderView=()=>{
  let{name,actionType}=this.state
  let{canEdit}=this.props
  if(actionType=='VIEW'){
      return(<span>
          <div className="singleInsightViewTitle"> {name} </div>
        </span>)
  } 
  
  if(canEdit){
    if (actionType=='EDIT' && canEdit) {
      return (
        <div className="" >
              
              <span className="singleInsightViewContainerOptions">
              
              <span className="singleInsightViewContainerBtn btn-outline-info"
              onClick={()=>this.props.changeInsightAction('VIEW')}> Back to View <i className='flaticon-vision'/> </span>

                
                  <span className="singleInsightViewContainerBtn btn-success"
                  onClick={()=>this.submitInsightTitle()}> Save <i className='flaticon-edit'/> </span>

                    <span className="singleInsightViewContainerBtn btn-outline-primary"
                    onClick={()=>this.props.changeInsightAction('CREATE')}> Add Insight 
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                    </span>

                  <span className="singleInsightViewContainerBtn btn-outline-secondary"
                  onClick={()=>this.openCreateChartReport()}> All Insights <i className='flaticon-paper'/> </span>
                  </span>
                          <div className="singleInsightAddTitleContainer">
                          <Input type="text" onChange={this.handleChangeInsightTitle} 
                              value={name}
                              placeholder={'Name this Insight (optional)'} 
                              className="singleInsightAddTitleInput" maxLength={64} /> 
                          </div>
        </div>
      )
    } else {
      return (
        <div className="" >        

        <span className="singleInsightViewContainerOptions">

            <span className="singleInsightViewContainerBtn btn-primary"
            onClick={()=>this.submitInsightTitle()}> Create <i className='flaticon-edit'/> </span>


            <span className="singleInsightViewContainerBtn btn-outline-secondary"
            onClick={()=>this.openCreateChartReport()}> All Insights <i className='flaticon-close'/> </span>
          </span>


                    <div className="singleInsightAddTitleContainer">
                    <Input type="text" onChange={this.handleChangeInsightTitle} 
                        value={name}
                        placeholder={'Name this Insight (optional)'} 
                        className="singleInsightAddTitleInput" maxLength={64} /> 
                    </div>
            </div>
      )
    }
  }
}

 
render() { 
    return  this.renderView() 
}


}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReportCharts:(dashboard)=> dispatch(actionCreators.updateReportCharts(dashboard)),

  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(InsightTitle, axios)));



